
<div class="body-container mx-auto">
  <form class="reg-form" [formGroup]="form" (ngSubmit)="onContinue()">
    <header>
      <h1 class="page-title text-center">Registration</h1>
    </header>
    <div class="reg-form-content">
      <p class="page-subtitle text-center mt-3 mb-4">
        Welcome to Camp Bow Wow<sup>&#174;</sup>!<br />
        Please fill out your info to continue.
      </p>

      <div class="row no-gutters">
        <div class="col" style="padding-right: 0.625rem">
          <div class="input-container">
            <span class="input-label">First Name</span>
            <input type="text" class="input" formControlName="firstName" />
            <span
              class="error"
              *ngIf="f.firstName.touched && f.firstName.value === ''"
              >Please enter first name.</span
            >
          </div>
        </div>
        <div class="col" style="padding-left: 0.625rem">
          <div class="input-container">
            <span class="input-label">Last Name</span>
            <input type="text" class="input" formControlName="lastName" />
            <span
              class="error"
              *ngIf="f.lastName.touched && f.lastName.value === ''"
              >Please enter last name.</span
            >
          </div>
        </div>
      </div>

      <div formGroupName="phone" class="row no-gutters">
        <div class="col-7 input-container" style="padding-right: 0.625rem">
          <span class="input-label">Phone Number</span>
          <div class="d-flex bd-highlight">
            <select class="input" style="width: auto" disabled="true">
              <option selected="selected" value="+1">+1</option>
            </select>
            <input
              type="text"
              class="input"
              formControlName="phoneNumber"
              mask="(000) 000-0000"
            />
          </div>
          <span
            *ngIf="
              f.phone.get('phoneNumber').touched &&
              f.phone.get('phoneNumber').value === ''
            "
            class="error"
            >Please enter phone number.</span
          >
          <span
            *ngIf="
              f.phone.get('phoneNumber').touched &&
              f.phone.get('phoneNumber').hasError('pattern') &&
              f.phone.get('phoneNumber').value !== ''
            "
            class="error"
            >Please check phone number.</span
          >
        </div>

        <div
          class="dropdown col-5 input-container"
          style="padding-left: 0.625rem"
        >
          <span class="input-label">Type</span>
          <mat-form-field class="input">
            <mat-select formControlName="phoneType">
              <mat-option
                *ngFor="let phoneType of myProfileService.phoneTypeList"
                [value]="phoneType"
                >{{ phoneType.type }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="action-container">
        <button
          type="submit"
          class="btn btn-danger btn-block"
          [disabled]="form.invalid"
        >
          Continue
        </button>
      </div>
    </div>
  </form>
</div>
